import React from "react";
import "./ExplanationSection.css";

const ExplanationSection = () => {
  return (
    <section className="explanation-section-main-container">
      <div className="container">
        <div className="explanation-section-two-column-grid">
          <div className="explanation-text-left-column">
            <h2 className="explanation-section-main-title-heading">
              Qu'est-ce que Monagora ?
            </h2>
            <p className="section-subtitle-descriptive-text">
              Monagora révolutionne la prise de rendez-vous pour les entreprises 
              grâce à l'intelligence artificielle et l'automatisation.
            </p>
            
            <div className="explanation-points-vertical-list-container">
              <div className="explanation-point-individual-card-item">
                <div className="explanation-point-content-text-wrapper">
                  <h4>Intelligence Artificielle</h4>
                  <p>Notre IA analyse votre planning et propose automatiquement les créneaux optimaux</p>
                </div>
              </div>
              
              <div className="explanation-point-individual-card-item">
                <div className="explanation-point-content-text-wrapper">
                  <h4>Envoi Automatique</h4>
                  <p>Emails personnalisés envoyés automatiquement à vos clients avec liens uniques</p>
                </div>
              </div>
              
              <div className="explanation-point-individual-card-item">
                <div className="explanation-point-content-text-wrapper">
                  <h4>Planning Optimisé</h4>
                  <p>Gestion intelligente des conflits et optimisation des créneaux en temps réel</p>
                </div>
              </div>
              
              <div className="explanation-point-individual-card-item">
                <div className="explanation-point-content-text-wrapper">
                  <h4>Multi-Entreprises</h4>
                  <p>Adapté à tous les secteurs : plomberie, électricité, climatisation, services</p>
                </div>
              </div>
              
              <div className="explanation-point-individual-card-item">
                <div className="explanation-point-content-text-wrapper">
                  <h4>Application Mobile</h4>
                  <p>Interface mobile complète pour gérer vos rendez-vous où que vous soyez</p>
                </div>
              </div>
              
              <div className="explanation-point-individual-card-item">
                <div className="explanation-point-content-text-wrapper">
                  <h4>Configuration Simple</h4>
                  <p>Mise en place rapide sans formation complexe, résultats immédiats</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="explanation-visual-right-column-sticky">
            <div className="modern-process-flow-main-container">
              <div className="process-workflow-title-header-section">
                <div className="process-workflow-main-title-heading">
                  <h3>Comment ça marche</h3>
                </div>
                <div className="process-workflow-subtitle-description-text">
                  <p>Un processus automatisé de bout en bout</p>
                </div>
              </div>
              
              <div className="workflow-steps-vertical-container-list">
                <div className="workflow-step-individual-card-item workflow-step-individual-card-item--active-state">
                  <div className="workflow-step-icon-container-element">📊</div>
                  <div className="workflow-step-content-text-wrapper">
                    <h4>Import Excel</h4>
                    <p>Vous importez votre fichier Excel avec tous vos clients</p>
                  </div>
                </div>
                
                <div className="workflow-step-connector-line-element">
                  <div className="workflow-connector-vertical-line-gradient"></div>
                  <div className="workflow-connector-animated-pulse-dot"></div>
                </div>
                
                <div className="workflow-step-individual-card-item">
                  <div className="workflow-step-icon-container-element">📧</div>
                  <div className="workflow-step-content-text-wrapper">
                    <h4>Email Automatique</h4>
                    <p>Chaque client reçoit un email personnalisé avec lien unique</p>
                  </div>
                </div>
                
                <div className="workflow-step-connector-line-element">
                  <div className="workflow-connector-vertical-line-gradient"></div>
                  <div className="workflow-connector-animated-pulse-dot"></div>
                </div>
                
                <div className="workflow-step-individual-card-item">
                  <div className="workflow-step-icon-container-element">🎯</div>
                  <div className="workflow-step-content-text-wrapper">
                    <h4>Prise de RDV</h4>
                    <p>Le client clique et choisit son créneau en temps réel</p>
                  </div>
                </div>
                
                <div className="workflow-step-connector-line-element">
                  <div className="workflow-connector-vertical-line-gradient"></div>
                  <div className="workflow-connector-animated-pulse-dot"></div>
                </div>
                
                <div className="workflow-step-individual-card-item workflow-step-individual-card-item--success-state">
                  <div className="workflow-step-icon-container-element">📱</div>
                  <div className="workflow-step-content-text-wrapper">
                    <h4>Sync Mobile</h4>
                    <p>RDV automatiquement synchronisé dans votre app mobile</p>
                  </div>
                </div>
              </div>
              
              <div className="process-statistics-grid-container">
                <div className="process-statistic-individual-card-item">
                  <div className="process-statistic-number-value-display">0 min</div>
                  <div className="process-statistic-label-description-text">Travail manuel</div>
                </div>
                <div className="process-statistic-individual-card-item">
                  <div className="process-statistic-number-value-display">100%</div>
                  <div className="process-statistic-label-description-text">Automatique</div>
                </div>
                <div className="process-statistic-individual-card-item">
                  <div className="process-statistic-number-value-display">24/7</div>
                  <div className="process-statistic-label-description-text">Disponible</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExplanationSection; 